// import Marker from './marker'
import { REP, SRC_GEN, LANG, REP_MARK, BRAND, REP_SCH, MISC_IMG, USR_REP } from '../Data/typeDirs'
import { REP_SECTIONS } from '../Data/consts'
import { genId } from '../utils'
// import {
//   createDropboxFolder,
//   checkDropboxPath,
//   fileCopy,
//   deleteDropboxFile,
//   getFullDropboxDirListing,
//   filesGetThumbnailBatch,
//   fullCopyBatch
// } from '../Services/dropbox'

import { traverseSchema } from '../ControlManager/scripts/utils'
import ReportMarker from './reportMarker'
import { BasicManagedFile } from './basicManagedFile'
import { ControlManagerContainerContent } from '../ControlManager/container/content'
import { DateToFormattedString } from '../utils'
import MiscImage from './miscImage'
const PHOTOS_SM = 'photos_sm'
// const photoPath = `/${DROPDIR}/${dir}/${repMark}`
const ARCHDIR = '/Archive'
const BLOCK_ESC = '---'
const REP_BLOCK_TAG = `report_block${BLOCK_ESC}`
const PRE_TAG = `preamble${BLOCK_ESC}`

const DROPDIR = '/MetaStoryFiles'

export default class Report extends BasicManagedFile {
  constructor(args) {
    super(args)
    this.ext = 'rpt.json'
    //    this.directory = loc(REP)
    //this.name = this.getName()
    this.typeDir = Report.getTypeDir()
    this.setSchemas()
    this.setSources()
  }

  construct(data) {
    // console.log('going to construct report with', data)
    super.construct(data)
    this.setSchemas()
    this.coverPageContent = data.coverPageContent
    this.reportSections = data.reportSections
    this._language_v2 = data._language_v2
    // this._createdFor = data._createdFor
    this.users = data.users
    this._property = data._property
    this.langId = data.langId
    // console.log('saving report', data)
    this.schema = data.schema
    this.dirName = data.dirName || `${data.name}-${DateToFormattedString(new Date(this.created), true)}` || this.name
    this._client = data._client
    // this.setSources()
    return this
  }




  static getIndices() {
    return `${super.getIndices()},dirName,_property,_createdFor,_language_v2,_client`
  }

  static async initDefault(ds, langId, title, schemaId) {
    let pms = await ds[SRC_GEN].getTyped({ name: 'ProjectManagerStatement' })
    let schema = await ds[REP_SCH].getTyped({ _id: schemaId })
    let lang
    if (langId) {
      lang = await ds[LANG].getTyped({ _id: langId })
      lang = lang.getLanguage()
    }
    schema = schema.content.getData()._reportSchema
    // console.log('got ProjectManagerStatement', pms, lang)

    return Report.initialize(pms, lang, title, schema)
  }

  static initialize(pms = {}, lang = {}, title, schema) {
    // console.log('initialize...', pms, title)
    // set _reportSchema.source.language to lang
    return {
      "_reportSchema": {
        ...schema,
        "source": {
          ...schema.source,
          language: lang
        }
      },
      "title": {
        "schema": [
          {
            "name": 'title',
            "type": 'text',
            "label": 'Report Title',
            "options": ['edit'],
            "source": 'title'
          },
          {
            name: 'address',
            label: 'Property Address',
            type: 'text',
            options: ['edit', 'large', 'markdown'],
          },
          {
            "name": 'repType',
            "type": 'text',
            "label": 'Report Type',
            "options": ['edit']
          },
          {
            "name": 'coverPhoto',
            "type": 'imageControl',
            "label": 'Cover Photo',
            "options": ['edit', 'large', 'copy', 'type:report_cover']
          },
          {
            name: 'preparedForName',
            type: 'text',
            label: 'Prepared For',
            options: ['edit'],
          },
          {
            name: 'preparedForAddress',
            type: 'text',
            label: 'Prepared For Address',
            options: ['edit', 'large', 'markdown'],
          },
          {
            name: 'preparedForPhoto',
            type: 'imageControl',
            label: 'Prepared For Photo',
            options: ['edit', 'large', 'copy', `type:${BRAND}`],
          },
          {
            name: 'preparedByName',
            type: 'text',
            label: 'Prepared By',
            options: ['edit'],
          },
          {
            name: 'preparedByAddress',
            type: 'text',
            label: 'Prepared By Address',
            options: ['edit', 'large', 'markdown'],
          },
          {
            name: 'preparedByPhoto',
            type: 'imageControl',
            label: 'Prepared By Logo/Photo',
            options: ['edit', 'large', 'copy', `type:${BRAND}`],
          },
          { "name": 'date', "type": 'text', "label": 'Date', "options": ['edit'] }
        ],
        "source": {
          "title": [title],
          "reportTypes": [
            {
              "_name": 'PNA',
            },
            {
              "_name": 'O&M',
            }
          ]
        }
      },
      "summary": {
        "schema": [
          {
            "name": 'projectManagerStatement',
            "type": 'text',
            "label": 'Project Manager Statement',
            "options": ['edit', 'large', 'markdown'],
            "source": 'statement',
          },
          {
            "name": 'executiveSummary',
            "type": 'text',
            "label": 'Executive Summary',
            "options": ['edit', 'large', 'markdown'],
          },
          {
            "name": 'signature',
            "type": 'imageControl',
            "label": 'Signature',
            "options": ['edit', 'large', 'copy', 'type:signature'],
          },
          {
            "name": 'signatureTitle',
            "type": 'text',
            "label": "Signator's Title",
            "options": ['edit'],
          },
          {
            "name": 'signatureName',
            "type": 'text',
            "label": "Signator's Name",
            "options": ['edit'],
          }

        ],
        "source": pms.getGenericSource()
      },
      "_preambleSchema": {
        "schema": [
          {
            "name": 'title',
            "type": 'text',
            "label": 'Title',
            "options": ['edit', 'copy']
          },
          {
            name: 'textBlock1',
            type: 'text',
            label: 'Text Block 1',
            options: ['edit', 'large', 'copy', 'markdown']
          },
          {
            "name": 'image',
            "type": 'imageControl',
            "label": 'Image',
            "options": ['edit', 'large', 'copy', 'type:report_preamble']
          },
          {
            "name": 'caption',
            "type": 'text',
            "label": 'Caption',
            "options": ['edit', 'large', 'copy']
          },
          {
            name: 'textBlock2',
            type: 'text',
            label: 'Text Block 2',
            options: ['edit', 'large', 'copy', 'markdown']
          }
        ]
      },
      "reportSectionSelector": {
        "schema": [
          {
            "name": 'reportSectionSelector',
            "type": 'multiselect',
            "label": 'Report Section Selector',
            "options": ['edit'],
            "source": 'reportSection.reportSection',
          }
        ],
        "source": {
          "reportSection": {
            "reportSection": REP_SECTIONS.map(itm => ({ "_name": itm }))
          }
        }
      }
    }
  }
  //using Mongoose Models, find and archive rep(_id) and children
  static async archive(fileModels, _id) {
    let { Main, Archive, Versions } = fileModels[REP]
    let RepMarkMain = fileModels[REP_MARK].Main

    let repMarksToArchive,
      repMarkArchiveResults,
      repArchiveCreateRes,
      repVersionsDeleteManyRes,
      repDeleteSelfRes,
      repToArchive,
      usr_rep_entriesToArchive,
      usr_rep_entriesToArchiveResults,
      usr_rep_entriesDeleteResults

    try {
      repMarksToArchive = await RepMarkMain.find({ _report: _id }).exec()
      console.log('repMarksToArchive', repMarksToArchive.length)
      // return
      repMarkArchiveResults = []
      for (let repMark of repMarksToArchive) {
        // console.log('archiving repMark', repMark._id)
        let res = await ReportMarker.archive(fileModels, repMark._id, repMark)
        repMarkArchiveResults.push(res)
      }
      const idsToDelete = repMarksToArchive.map(itm => itm._id)
      let repMarkVersionsDeleteManyRes = await fileModels[REP_MARK].Versions.deleteMany({ _parentId: { $in: idsToDelete } })
      console.log('deleted versioned rep marks', repMarkVersionsDeleteManyRes.deletedCount)
      let repMarkMainDeleteManyRes = await fileModels[REP_MARK].Main.deleteMany({ _id: { $in: idsToDelete } })
      console.log('deleted rep marks', repMarkMainDeleteManyRes.deletedCount)

    } catch (e) {
      console.log('failed archiving reportMarkers', e.message, repMarkArchiveResults)
      // for(let res of repMarkArchiveResults) console.log(res)

    }

    try {
      let { Main: USR_REP_Main, Archive: USR_REP_Archive } = fileModels[USR_REP]
      usr_rep_entriesToArchive = await USR_REP_Main.find({ _report: _id }).exec()
      usr_rep_entriesToArchiveResults = []
      for (let usr_rep of usr_rep_entriesToArchive) {
        console.log('archiving user reference', usr_rep._id)
        let res = await USR_REP_Archive.findOneAndUpdate({ _id: usr_rep._id }, usr_rep, { upsert: true }).exec()
        usr_rep_entriesToArchiveResults.push(res)

      }
      let delRes = await USR_REP_Main.deleteMany({ _report: _id }).exec()
      usr_rep_entriesDeleteResults = delRes

    } catch (e) {
      console.log('failed archiving user references', e.message, usr_rep_entriesToArchiveResults, usr_rep_entriesDeleteResults)
    }

    try {
      repToArchive = await Main.findOne({ _id }).exec()
      console.log('got repToArchive')
      repArchiveCreateRes = await Archive.findOneAndUpdate({ _id }, repToArchive, { upsert: true }).exec()
      console.log('got repArchiveCreateRes')
      repVersionsDeleteManyRes = await Versions.deleteMany({ _parentId: _id }).exec()
      console.log('got repVersionsDeleteManyRes')
      repDeleteSelfRes = await Main.deleteOne({ _id }).exec()
      console.log('got repDeleteSelfRes')
    } catch (e) {
      console.log('failed archiving report',
        repArchiveCreateRes,
        repVersionsDeleteManyRes,
        repDeleteSelfRes,
        e
      )
    }
    return repToArchive
  }

  //using Mongoose Models, find and archive rep(_id) and children
  static async delete(fileModels, _id, killDropboxPhotos, dropboxRequests) {
    const {deleteDropboxFile} = dropboxRequests
    let { Main, Versions } = fileModels[REP]
    let RepMarkMain = fileModels[REP_MARK].Main

    let repMarksToDelete,
      repMarkDeleteResults,
      repDeleteCreateRes,
      repVersionsDeleteManyRes,
      repDeleteSelfRes,
      repToDelete,
      usr_rep_entriesDeleteResults

    try {
      repMarksToDelete = await RepMarkMain.find({ _report: _id }).lean()
      // console.log('repMarksToDelete', repMarksToDelete)
      // return
      const idsToDelete = repMarksToDelete.map(itm => itm._id)
      let repMarkVersionsDeleteManyRes = await fileModels[REP_MARK].Versions.deleteMany({ _parentId: { $in: idsToDelete } })
      console.log('deleted versioned rep marks', repMarkVersionsDeleteManyRes.deletedCount)
      let repMarkMainDeleteManyRes = await fileModels[REP_MARK].Main.deleteMany({ _id: { $in: idsToDelete } })
      console.log('deleted rep marks', repMarkMainDeleteManyRes.deletedCount)
      // for (let repMark of repMarksToDelete) {
      //   console.log('deleting repMark', repMark._id)
      //   let res = await ReportMarker.delete(fileModels, repMark._id, repMark)
      //   repMarkDeleteResults.push(res)
      // }


    } catch (e) {
      console.log('failed deleting reportMarkers', e.message, repMarkDeleteResults)
      // for(let res of repMarkDeleteResults) console.log(res)

    }
    try {
      let { Main: USR_REP_Main } = fileModels[USR_REP]
      usr_rep_entriesDeleteResults = await USR_REP_Main.deleteMany({ _report: _id }).exec()
      console.log('deleted user references', usr_rep_entriesDeleteResults.deletedCount)
    } catch (e) {
      console.log('failed archiving user references', e.message, usr_rep_entriesDeleteResults)
    }

    try {
      repToDelete = await Main.findOne({ _id }).exec()
      console.log('got repToDelete')
      // repDeleteCreateRes = await Delete.findOneAndUpdate({_id}, repToDelete, {upsert:true}).exec()
      // console.log('got repDeleteCreateRes')
      repVersionsDeleteManyRes = await Versions.deleteMany({ _parentId: _id }).exec()
      console.log('got repVersionsDeleteManyRes')
      repDeleteSelfRes = await Main.deleteOne({ _id }).exec()
      console.log('got repDeleteSelfRes')
    } catch (e) {
      console.log('failed archiving report',
        repDeleteCreateRes,
        repVersionsDeleteManyRes,
        repDeleteSelfRes,
        e
      )
    }

    if (killDropboxPhotos) {
      const dropboxDir = Report.getDropboxDirectory(repToDelete.dirName)
      const archiveDir = Report.getDropboxArchiveDirectory(repToDelete.dirName)
      console.log('killing dbx photos', repToDelete.name, dropboxDir, archiveDir)
      // return repToDelete
      try {
        await deleteDropboxFile(dropboxDir)
        console.log('deleted dropbox dir')
      } catch (e) {
        console.log('Failed deleting dropbox folder', dropboxDir, e.error)
      }

      try {
        await deleteDropboxFile(archiveDir)
        console.log('deleted archive dir')
      } catch (e) {
        console.log('Failed deleting archive dir', archiveDir, e.error)
      }
    }
    return repToDelete
  }

  static getDropboxArchiveDirectory(dirName = "FAILED", full) {
    return `${ARCHDIR}/${REP_MARK}/${dirName}${full ? '/photos' : ''}`
  }

  static getDropboxDirectory(dirName = "FAILED", full) {
    return `${DROPDIR}/${REP_MARK}/${dirName}${full ? `/${PHOTOS_SM}` : ''}`
  }

  static async killLocalPhotos(locRoot, name, kill) {
    return await kill(`${locRoot}/${REP_MARK}/${name}`)
  }

  static async killDropboxPhotos(name, token, dropboxRequests) {
    const {deleteDropboxFile} = dropboxRequests
    let res = await deleteDropboxFile(`${DROPDIR}/${REP_MARK}/${name}`, token)
    console.log('deleted dropbox folder for report', name, 'with response', res)
    return res
  }

  static async killLocalDBRecords(localdb, name, _id) {
    // let rep
    if (!_id) {
      let res = await localdb[REP].get({ name })
      _id = res._id
    }
    console.log('going to try to kill report', name, _id)
    // else if(name) rep = await localdb[REP].get({_id})
    let repMarks = await localdb[REP_MARK].where({ _report: _id })
    repMarks = await repMarks.toArray()
    console.log('got repMarks to delete', repMarks)
    for (let repMark of repMarks) {
      console.log('going to kill repMark', repMark._id)
      await ReportMarker.killLocalDBRecords(localdb, repMark._id)
    }

    return await localdb[REP].kill({ _id })
  }

  static async getLocalMiscImgs(root, readDir, checkIfExists) {
    const localDir = `${root}/${MISC_IMG}/${PHOTOS_SM}`
    // console.log('local dir', localDir)
    let dirContents = []
    try {
      let exists = await checkIfExists(localDir)
      if (exists) {
        dirContents = await readDir(localDir)
      }
    } catch (e) {
      // console.log('failed reading directory for counting local insp fin photos', e)
    }
    // console.log('read dir for insp fin', dirContents)
    return dirContents
  }

  static async getCurrentPhotoStatus(id, ds, locRoot, readDir, checkIfExists, checkOptions = { dropbox: true, local: true, misc: true }, miscImgs = {}, obj, dropboxRequests) {
    //REMEMBER LOCAL ISNT REALLY LOCAL ANYMORE, ITS THE NUMBER OF PHOTOS IN THE REPORT - NUMBER OF PHOTOS NOT ON MACHINE
    const {
      getFullDropboxDirListing
    } = dropboxRequests
    if (!obj) obj = await ds[REP].getTyped({ _id: id })
    let archDir = `${DROPDIR}/${REP_MARK}/${obj.dirName}/${PHOTOS_SM}`
    let miscDir = `${DROPDIR}/${MISC_IMG}/${PHOTOS_SM}`
    let dbxPhotos = []
    let dbxMiscImgs = []
    if (checkOptions.dropbox) {
      if (!checkOptions.misc && miscImgs.dropbox) {
        dbxMiscImgs = miscImgs.dropbox
      } else if (checkOptions.misc) {
        dbxMiscImgs = await getFullDropboxDirListing(miscDir, true)
      }
      dbxPhotos = await getFullDropboxDirListing(archDir, true)
      dbxPhotos = dbxPhotos || []
    }

    let rptMiscImgIds = []
    rptMiscImgIds = await obj.getMiscImageIds()
    // dbxPhotos = dbxPhotos || []
    // console.log('got dropdir of photos', dbxPhotos)

    let localMiscImgs = []
    let currentImgIds = []
    currentImgIds = await obj.getCurrentImageIds()
    let localPhotoList = []
    if (checkOptions.local) {
      if (!checkOptions.misc && miscImgs.local) {
        localMiscImgs = miscImgs.local
      } else if (checkOptions.misc) {
        localMiscImgs = await Report.getLocalMiscImgs(locRoot, readDir, checkIfExists)
      }
      localPhotoList = await obj.getLocalPhotoList(locRoot, readDir, checkIfExists)
    }

    let missingPhotos = []
    let missingMiscPhotos = []
    let failedRemotes = []
    let failedMiscRemotes = []
    for (let _id of currentImgIds) {
      // console.log('checking before exists find', dbxPhotos, miscImgs, checkOptions, obj)
      let localPhotoExists = localPhotoList.find(itm => itm.includes(_id))
      let remotePhotoExists = dbxPhotos.find(itm => itm.includes(_id))
      if (!localPhotoExists) missingPhotos.push(_id)
      if (!remotePhotoExists && checkOptions.dropbox) {
        console.warn('Remote Photo doesnt exist. Possibly not uploaded.', obj.dirName, _id)
        failedRemotes.push(_id)
      }

    }

    for (let _id of rptMiscImgIds) {
      let localPhotoExists = localMiscImgs.find(itm => itm.includes(_id))
      let remotePhotoExists = dbxMiscImgs && dbxMiscImgs.find(itm => itm.includes(_id))
      if (!localPhotoExists) missingMiscPhotos.push(_id)
      if (!remotePhotoExists && checkOptions.dropbox) {
        console.warn('Remote Photo doesnt exist. Possibly not uploaded.', obj.dirName, _id)
        failedMiscRemotes.push(_id)
      }

    }
    // let miscImgIds = getMiscImageIds()
    const localRemoteStatus = {
      remote: currentImgIds.length + rptMiscImgIds.length,
      local: (currentImgIds.length + rptMiscImgIds.length) - (missingPhotos.length + missingMiscPhotos.length)
    }
    return {
      currentImgIds,
      missingPhotos,
      failedRemotes,
      obj,
      rptMiscImgIds,
      missingMiscPhotos,
      failedMiscRemotes,
      localRemoteStatus
    }
  }

  static async addMissingPhotosToQueue(id, ds, locRoot, readDir, checkIfExists, getLocal, setLocal, photoManager) {
    let {
      missingPhotos,
      obj,
      missingMiscPhotos,
      localRemoteStatus
    } = await this.getCurrentPhotoStatus(id, ds, locRoot, readDir, checkIfExists)

    let markCountRep = await getLocal('markCountRep')
    markCountRep[id] = localRemoteStatus
    await setLocal('markCountRep', markCountRep)
    if (missingMiscPhotos.length) await photoManager.addToQueue({ dir: `${MISC_IMG}`, photos: missingMiscPhotos })
    if (missingPhotos.length) await photoManager.addToQueue({ dir: `${REP_MARK}/${obj.dirName}`, photos: missingPhotos })
    return [
      missingPhotos,
      missingMiscPhotos
    ]
  }

  static async getAllDropboxThumbnailsAsImageMap(realReport, progress, dropboxRequests, userToken) {
    const {filesGetThumbnailBatch} = dropboxRequests 
    let allImgIds = [
      ...realReport.getCurrentImageIds().map(itm => ({_id:itm._id, storageLocation:'dropbox', thumbnailSize: 'md', path:ReportMarker.getDropboxArchivePath(itm, realReport.dirName)})),
      ...realReport.getMiscImageIds().map(itm => ({_id:itm._id, storageLocation:'dropbox', thumbnailSize: 'md', path:MiscImage.getDropboxArchivePath(itm, realReport.dirName)}))
    ]
    let count = 0
    const totalImages = allImgIds.length
    let failedImages = []
    let resultMapper = (results) => {
      let arr = []
      console.log('new batch', results)
      for (let res of results) {
        if (res.failure) {
          console.log('failed making thumbnail?', res)
          failedImages.push(res)
          continue
        }
        try {
          // let thumb = window.URL.createObjectURL(res.thumbnail)
          arr.push({
            url: res.thumbnail,
            _id: !res.metadata.name.includes('_') ?
              res.metadata.name.split('.')[0] : res.metadata.name.split('_')[0]
          })
        } catch (e) {
          console.log('failed getting URL', e)
        }
      }
      count += results.length
      let message = `Getting images from Dropbox... (${count} / ${totalImages}) # errors: ${failedImages.length}`
      progress(count, totalImages, message)
      return arr
    }
    // progress(0)
    // console.log('all imgIds', allImgIds)
    let thumbnailArr = []
    // if (!getThumbs) thumbnailArr = await filesGetThumbnailBatch(allImgIds, resultMapper)
    while(allImgIds.length){
      let bin = allImgIds.splice(0, 25)
      let newThumbs = await filesGetThumbnailBatch(bin, resultMapper, userToken)
      thumbnailArr = [...thumbnailArr, ...resultMapper(newThumbs)]
    }
    // console.log('got thumbs', thumbnailArr.length)
    let thumbnailObj = {}
    for (let i = 0; i < thumbnailArr.length; i++) {
      let { url, _id } = thumbnailArr[i]
      thumbnailObj[_id] = url
    }
    return thumbnailObj
  }

  static async archivePhotos(name, token, locRoot, kill, ds, dropboxRequests) {
    const {
      createDropboxFolder,
      checkDropboxPath,
      deleteDropboxFile,
      fileCopy,
      // getFullDropboxDirListing,
    } = dropboxRequests
    let rep = await ds('remDb')[REP].get({ name })
    let archDir = `${ARCHDIR}/${REP_MARK}/${rep.dirName}/${PHOTOS_SM}`
    let dropboxDir = `${DROPDIR}/${REP_MARK}/${rep.dirName}/${PHOTOS_SM}`
    try {
      await createDropboxFolder(archDir, token)

    } catch (e) { console.log('failed creating dropbox folder for rep', e) }
    // console.log('created folders for placement')
    let fromExists = await checkDropboxPath(dropboxDir, token)
    let toExists = await checkDropboxPath(archDir, token)
    if (!fromExists) {
      console.warn('Dropbox from path in archive report doesnt exist ', dropboxDir)
      return false
    }
    if (toExists) await deleteDropboxFile(archDir, token)
    // let inspFin = await ds('remDb')[REP].get({name})
    // let dirName = genEntityName(name, inspFin._id)
    let copyRes = await fileCopy(dropboxDir, archDir, token)
    // let newFolder = await getFullDropboxDirListing(archDir, token)
    // let archOrigFolder = await getFullDropboxDirListing(`${ARCHDIR}/${REP_MARK}/${rep.dirName}/photos/`, token)

    // console.log('finished copy report photos to archive', copyRes, newFolder.length, archOrigFolder.length)
    await Report.killDropboxPhotos(rep.dirName, token)
    await Report.killLocalPhotos(locRoot, rep.dirName, kill)
    // await Report.killDropboxPhotos(name, token)
    return copyRes
  }

  // am fat and retarded sue me
  static async unarchive(fileModels, _id) {
    let { Main, Archive } = fileModels[REP]
    let RepMarkArch = fileModels[REP_MARK].Archive

    let repMarksToUnarchive,
      repMarkUnarchiveResults,
      repUnarchiveCreateRes,
      repVersionsDeleteManyRes,
      repDeleteArchiveRes,
      repToUnarchive,
      usr_rep_entriesToUnarchive,
      usr_rep_entriesToUnarchiveResults,
      usr_rep_entriesDeleteResults

    try {
      repMarksToUnarchive = await RepMarkArch.find({ _report: _id }).exec()
      console.log('repMarksToUnarchive', repMarksToUnarchive.length)
      // return
      repMarkUnarchiveResults = 0
      for (let repMark of repMarksToUnarchive) {
        // console.log('unarchiving repMark', repMark._id)
        await ReportMarker.unarchive(fileModels, repMark._id, repMark)
        repMarkUnarchiveResults++
      }
      const idsToDelete = repMarksToUnarchive.map(itm => itm._id)
      let repMarkMainDeleteManyRes = await fileModels[REP_MARK].Archive.deleteMany({ _id: { $in: idsToDelete } })
      console.log('deleted rep marks', repMarkMainDeleteManyRes.deletedCount)

    } catch (e) {
      console.log('failed archiving reportMarkers', e.message, repMarkUnarchiveResults)
      // for(let res of repMarkUnarchiveResults) console.log(res)

    }

    try {
      let { Main: USR_REP_Main, Archive: USR_REP_Archive } = fileModels[USR_REP]
      usr_rep_entriesToUnarchive = await USR_REP_Archive.find({ _report: _id }).exec()
      usr_rep_entriesToUnarchiveResults = []
      for (let usr_rep of usr_rep_entriesToUnarchive) {
        console.log('unarchiving user reference', usr_rep._id)
        let res = await USR_REP_Main.findOneAndUpdate({ _id: usr_rep._id }, usr_rep, { upsert: true }).exec()
        usr_rep_entriesToUnarchiveResults.push(res)

      }
      let delRes = await USR_REP_Archive.deleteMany({ _report: _id }).exec()
      usr_rep_entriesDeleteResults = delRes

    } catch (e) {
      console.log('failed unarchiving user references', e.message, usr_rep_entriesToUnarchiveResults, usr_rep_entriesDeleteResults)
    }

    try {
      repToUnarchive = await Archive.findOne({ _id }).exec()
      console.log('got repToUnarchive')
      repUnarchiveCreateRes = await Main.findOneAndUpdate({ _id }, repToUnarchive, { upsert: true }).exec()
      console.log('got repUnarchiveCreateRes')
      // repVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
      // console.log('got repVersionsDeleteManyRes')
      repDeleteArchiveRes = await Archive.deleteOne({ _id }).exec()
      console.log('got repDeleteArchiveRes')
    } catch (e) {
      console.log('failed archiving report',
        repUnarchiveCreateRes,
        repVersionsDeleteManyRes,
        repDeleteArchiveRes,
        e
      )
    }
    return repToUnarchive
  }

  static async unarchivePhotos(name, token, locRoot, photoManager, ds, dropboxRequests) {
    const {
      checkDropboxPath,
      deleteDropboxFile,
      fileCopy,
    } = dropboxRequests
    let rep = await ds('remDb')[REP].get({ name })
    let archiveDir = `${ARCHDIR}/${REP_MARK}/${rep.dirName}/${PHOTOS_SM}`
    let dropboxDir = `${DROPDIR}/${REP_MARK}/${rep.dirName}/${PHOTOS_SM}`
    let checkArchRes
    let checkDestRes
    try {
      checkArchRes = await checkDropboxPath(archiveDir, token)
      checkDestRes = await checkDropboxPath(dropboxDir, token)


    } catch (e) { console.error('failed checking dropbox folder for rep markers', e, checkArchRes, checkDestRes) }
    console.log('checked archive folder', checkArchRes, checkDestRes)
    if (!checkArchRes) {
      console.warn('archive photos dont exist for report', name)
      return
    }
    if (checkDestRes) await deleteDropboxFile(dropboxDir, token)
    // let inspFin = await ds('remDb')[REP].get({name})
    // let dirName = genEntityName(name, inspFin._id)
    let copyRes
    try {
      copyRes = await fileCopy(archiveDir, dropboxDir, token)

    } catch (e) {
      console.error('failed copying from archive', e)
      return false
    }
    console.log('copyres for unarchivephotos in report', copyRes)
    // await Report.killDropboxArchivePhotos(rep.dirName, token)
    // await Report.addPhotosToQueue(ds, name, photoManager)
    // await Report.killDropboxPhotos(name, token)
    return copyRes
  }

  static async killDropboxArchivePhotos(name, token, dropboxRequests) {
    const {deleteDropboxFile} = dropboxRequests
    let res = await deleteDropboxFile(`${ARCHDIR}/${REP_MARK}/${name}`, token)
    console.log('deleted dropbox folder for report', name, 'with response', res)
    return res
  }

  static async addPhotosToQueue(ds, name, photoManager) {
    // let rep
    let res = await ds('remDb')[REP].getTyped({ name })
    // else if(name) rep = await localdb[REP].get({_id})
    let repMarks = await ds('remDb')[REP].getRepMarksByRep(res)
    // console.log('got rep marks to put', repMarks)
    for (let mark of repMarks.report_markers) await ds('db')[REP_MARK].put(mark)
    // repMarks = await repMarks.toArray()
    let marks = repMarks.report_markers.map(itm => itm._id)
    let miscImgIds = res.getMiscImageIds()
    let miscMarks = { dir: `${MISC_IMG}`, photos: [] }
    for (let id of miscImgIds) {
      miscMarks.photos.push(id)
    }
    await photoManager.addToQueue(miscMarks)

    photoManager.addToQueue({ dir: `${REP_MARK}/${res.dirName}`, photos: marks })
    // for(let repMark of repMarks.report_markers) photoManager.addToQueue({})

    return
  }

  static async copyToOppositeRem(original, fileModels, oppRemDb) {
    let markers = await fileModels[REP_MARK].Main.find({ _report: original._id }).exec()
    // console.log('before markers toArray')
    // markers = await markers.toArray()
    console.log('found markers', markers)
    // let oppRemMarkers = []
    try {
      // oppRemMarkers = await oppRemDb.gen('getRepMarksByRep', REP_MARK, original)
      // oppRemMarkers = oppRemMarkers && oppRemMarkers.report_markers

    } catch (e) {
      console.log('failed copyto attempting to get oppRemMarkers', e)
    }

    let missingMarks = markers

    if (missingMarks.length) {
      const bin_max = 50
      for (let i = 0; i < Math.ceil(missingMarks.length / bin_max); i++) {

        let s = i * bin_max
        let f = (i + 1) * bin_max
        let bin = missingMarks.slice(s, f)
        await oppRemDb.gen('bulkInsert', REP_MARK, bin)

      }

      // for (let mark of missingMarks){
      //   try{
      //     await oppRemDb.put(REP_MARK, mark)
      //   }catch(e){
      //     console.log('failed copyto putting mark to oppRemDb', e)
      //   }

      // }
    }
    oppRemDb.put(REP, original)
    return
  }

  static async duplicate(original, newName, dataSource, locRoot, checkIfExists, makeDir, moveFile, dropboxToken, syncPut, _createdFor = '', dropboxRequests) {
    const {
      checkDropboxPath,
      deleteDropboxFile,
      fileCopy
    } = dropboxRequests
    let { _id} = original.serialize()
    let newContent = original.content
    newContent.content.title.tree.title.content[0]._name = newName
    let newReport = new Report({
      content: newContent.content,
      name: newName,
      _createdFor
    })

    let { [REP_MARK]: originalRepMarkers } = await dataSource('remDb')[REP].getRepMarksByRep({ _id })

    let newRepMarkers = []
    let dropboxPhotosNotFound = []
    let localPhotosNotFound = []
    let newDropDir = `${DROPDIR}/${REP_MARK}/${newReport.dirName}/${PHOTOS_SM}`
    // let newLocalDir = `${locRoot}/${REP_MARK}/${newReport.dirName}/${PHOTOS_SM}/`

    let originalDropDir = `${DROPDIR}/${REP_MARK}/${original.dirName}/${PHOTOS_SM}`
    // let originalLocalDir = `${locRoot}/${REP_MARK}/${original.dirName}/${PHOTOS_SM}/`
    let originalDropDirExists, originalLocalDirExists, checkFolderRes, newLocalDirExists
    try {
      checkFolderRes = await checkDropboxPath(newDropDir)
      if (checkFolderRes) await deleteDropboxFile(newDropDir)
      // await createDropboxFolder(newDropDir)
      // await makeDir(newLocalDir, true)

      // originalLocalDirExists = await checkIfExists(originalLocalDir)
      // newLocalDirExists = await checkIfExists(newLocalDir)
      // if(originalLocalDirExists){
      //   await moveFile(originalLocalDir, newLocalDir, true)
      // }

      originalDropDirExists = await checkDropboxPath(originalDropDir)
      if (originalDropDirExists) {
        await fileCopy(originalDropDir, newDropDir, dropboxToken)
      }
      console.log('after copy of dbx photos', originalDropDirExists)

    } catch (e) {
      console.warn('Failed creating or copying directory', e, {
        checkFolderRes,
        originalLocalDirExists,
        originalDropDirExists,
        newLocalDirExists
      })
      return false
    }


    for (let o_marker of originalRepMarkers) {
      o_marker = new ReportMarker(o_marker)
      let { _id: o_id, name: o_name, dirName: o_dirName, _report, ...o_restOriginal } = o_marker.serialize()
      let newMark = new ReportMarker({
        ...o_restOriginal,
        _report: newReport._id
      })
      newRepMarkers.push(newMark)
      // // let o_dropboxPath = await o_marker.getDropboxPath(original.dirName, dataSource('db'))
      // let o_localPath = o_marker.getLocalPath(locRoot, original.dirName)
      // let newLocalPath = newMark.getLocalPath(locRoot, newReport.dirName)
      // // let newDropboxPath = await newMark.getDropboxPath(newReport.dirName, dataSource('db'))
      // let localExists = await checkIfExists(o_localPath)
      // // let dropboxExists = await checkDropboxPath(o_dropboxPath, dropboxToken)


      // if(localExists){
      //   await moveFile(o_localPath, newLocalPath, true)
      // }else localPhotosNotFound.push(o_marker._id)

      // if(dropboxExists){
      //   await fileCopy(o_dropboxPath, newDropboxPath, dropboxToken)
      // }else dropboxPhotosNotFound.push(o_marker._id)

      await dataSource('remDb')[REP_MARK].put(newMark.serialize())
      // await syncPut(REP_MARK, newMark.serialize())
    }

    console.log('finished duplicating with:', { newReport, newReportSerialized: newReport.serialize(), newRepMarkers, localPhotosNotFound, dropboxPhotosNotFound })
    return await dataSource('remDb')[REP].put(newReport.serialize())
    // return await syncPut(REP, newReport.serialize())
  }

  static getNewUserRef(_user, _report) {
    return { _id: genId(), _report, _user }
  }

  static async newDuplicate(original, newName, dataSource, locRoot, users = [], progress, dropboxRequests) {
    const {fullCopyBatch} = dropboxRequests
    let { _id} =original
    let rep = await dataSource('remDb')[REP].getTyped({ _id })
    let newContent = rep.content
    newContent.content.title.tree.title.content[0]._name = newName
    let newReport = new Report({
      content: newContent.content,
      name: newName,
      users,
      _language_v2: rep._language_v2
    })
    let repBlocks = newReport.getReportBlocks()
    let newMarkers = []
    let dbxCopyEntries = []
    for (let blockKey in repBlocks) {
      let block = repBlocks[blockKey]
      if (block.tree.images.content[0]) {
        let parsedBlock = JSON.parse(block.tree.images.content[0]._name)

        for (let img of parsedBlock) {
          let newMarker = new ReportMarker({ _report: newReport._id })
          newMarkers.push(newMarker)
          dbxCopyEntries.push({
            from_path: ReportMarker.getDropboxArchivePath(img.photo, original.dirName),
            to_path: ReportMarker.getDropboxArchivePath(newMarker._id, newReport.dirName)
          })
          img.photo = newMarker._id
        }
        block.tree.images.content[0]._name = JSON.stringify(parsedBlock)
      }
    }

    console.log('data compiled for duplicate', {
      original,
      repBlocks,
      newReport,
      newReportSerialized:
        newReport.serialize(),
      newMarkers,
      dbxCopyEntries
    })
    // if(newMarkers.len)
    // return 
    //this can be improved
    const BIN_MAX = 20
    progress(0, newMarkers.length)
    for (let i = 0; i < newMarkers.length; i += BIN_MAX) {
      let markBin = newMarkers.slice(i, i + BIN_MAX)
      let dbxBin = dbxCopyEntries.slice(i, i + BIN_MAX)
      let dbxRes
      let markRes
      try {
        dbxRes = await fullCopyBatch(dbxBin)
        console.log('copied images', i)
        markRes = await dataSource('remDb')[REP_MARK].bulkInsert(markBin)
        console.log('put markers', i)

      } catch (e) {
        console.warn('failed putting images or copying on dbx', e.message, { markBin, dbxBin, dbxRes, markRes })
      }
      progress(i + BIN_MAX, newMarkers.length)
    }

    return await dataSource('remDb')[REP].put({...newReport.serialize(), locked:null})
  }

  setReportSectionSelectorSourceToReportBlockSource() {
    let reportBlocks = this.getReportBlocks()

    for (let blockKey in reportBlocks) {
      // console.log('looking at', this.content.content)
      this.content.content[blockKey].source.reportSection = this.content.content.reportSectionSelector.source.reportSection
    }
    if (this.content.content._reportSchema.source && this.content.content.reportSectionSelector.source) {
      this.content.content._reportSchema.source.reportSection = this.content.content.reportSectionSelector.source.reportSection
    }
  }

  updateBlockKeys(fullUpdate = false) {
    // let keyConditionCallback = key =>
    //   Object.keys(this.getReportBlocks()).includes(key)


    // let replacements = {}
    // let actionCallback = (key, content) => {
    //   let oldBlock = content[key]
    //   // console.log('updating block keys with', oldBlock)

    //   let newKey = Report.getBlockKeyFromTree(oldBlock.tree)

    //   replacements[newKey] = { oldKey: key, newBlock: oldBlock }
    // }

    let content = this.getReportBlocks()





    let replacementKeys = Object.keys(content)
    // for()


    replacementKeys.sort((a, b) => {
      const aBlock = content[a].tree
      const bBlock = content[b].tree
      const aSource = content[a].source
      // const bSource = replacements[b].newBlock.source
      // console.log('got aBlock and bBlock', aBlock, bBlock, aSource)
      let aSecNum = aBlock.reportSection ?
        aSource.reportSection.reportSection.findIndex((itm) => itm._name === aBlock.reportSection.content[0]._name) : 0
      // aSecNum = aSecNum[aSecNum.length-1]
      let bSecNum = bBlock.reportSection ?
        aSource.reportSection.reportSection.findIndex((itm) => itm._name === bBlock.reportSection.content[0]._name) : 0
      // bSecNum = bSecNum[bSecNum.length-1]


      let arr = [aBlock, bBlock].filter(itm => (!itm.subcategory.content[0][`!fullNum`]))
      // console.log('comparing blocks:', {aBlock, bBlock, source:this.content.content._reportSchema.source, arr, replacements:replacements[a]})
      for (let blockMissingNum of arr) {
        traverseSchema(this.content.content._reportSchema.schema, this.content.content._reportSchema.source, blockMissingNum, (control, src, h) => {
          // console.log('traversing schema', blockMissingNum, control, src)
          if (control.name === 'subcategory' && blockMissingNum.subcategory.content[0]) {
            let srcBlock = src.filter(itm => itm._name === blockMissingNum.subcategory.content[0]._name)[0]
            blockMissingNum.subcategory.content[0][`!fullNum`] = srcBlock && srcBlock[`!fullNum`] ? srcBlock['!fullNum'] : `0`
            return false
          }
        })
      }

      let aFullNum = aBlock.subcategory.content[0][`!fullNum`]

      let bFullNum = bBlock.subcategory.content[0][`!fullNum`]
      // console.log('NUMS!', aFullNum, bFullNum)

      // aBlock.subcategory.content[0][`!fullNum`] = aBlock.subcategory.content[0][`!fullNum`]?
      //   aBlock.subcategory.content[0][`!fullNum`]:aBlock.subcategory.content[0][`!fullnum`]
      //
      // let aFullNum = aBlock.subcategory?aBlock.subcategory.content[0][`!fullNum`]:0||
      //   aBlock.category?aBlock.category.content[0][`!fullNum`]:0||
      //   aBlock.mastercat?aBlock.mastercat.content[0][`!fullNum`]:0
      //
      //   bBlock.subcategory.content[0][`!fullNum`] = bBlock.subcategory.content[0][`!fullNum`]?
      //     bBlock.subcategory.content[0][`!fullNum`]:bBlock.subcategory.content[0][`!fullnum`]
      //
      // let bFullNum = bBlock.subcategory?bBlock.subcategory.content[0][`!fullNum`]:0||
      //   bBlock.category?bBlock.category.content[0][`!fullNum`]:0||
      //   bBlock.mastercat?bBlock.mastercat.content[0][`!fullNum`]:0

      aFullNum = parseInt(`${aSecNum}${aFullNum.split('.').join('')}`)
      bFullNum = parseInt(`${bSecNum}${bFullNum.split('.').join('')}`)
      // console.log('got sort comparison', aFullNum<bFullNum, aFullNum, bFullNum)
      return aFullNum < bFullNum ? -1 : 1
    })

    let newContent = {}
    if (fullUpdate) {
      for (let key of replacementKeys) {
        // console.log('updating blockKeys with', key, content)
        const newBlockKey = Report.getBlockKeyFromTree(content[key].tree)
        newContent[newBlockKey] = content[key]
      }
    } else {
      for (let key of replacementKeys) {
        // let entry = content[key]
        newContent[key] = content[key]
        // if(entry.oldKey!==key){
        //   delete content[entry.oldKey]
        //   content = {...content, [key]: entry.newBlock}
        // }

      }
    }

    // console.log('replacement kleys sorted????', replacementKeys, replacements)


    let preservedOldContent = {}
    for (let key in this.content.content) {
      if (!Report.getShouldSortKey(key)) {
        preservedOldContent[key] = this.content.content[key]
      }
      // if(entry.oldKey!==key){
      //   delete content[entry.oldKey]
      //   content = {...content, [key]: entry.newBlock}
      // }

    }
    // console.log(
    //   'comparing new and old content',
    //   this.content.getData(),
    //   content,
    // )
    // let {title, summary, reportSectionSelector, _reportSchema} = content
    // console.log("end of key sort with object keys", Object.keys(newContent))



    this.content = new ControlManagerContainerContent({
      ...preservedOldContent,
      ...newContent
    })
    if (this._language_v2) {
      this.setSources()
      this.setSchemas()
    }

  }

  setReportBlocks(newContent) {
    // let preservedOldContent = {}
    // for (let key in this.content.content) {
    //   if(!Report.getShouldSortKey(key)){
    //     preservedOldContent[key] = this.content.content[key]
    //   }
    //   // if(entry.oldKey!==key){
    //   //   delete content[entry.oldKey]
    //   //   content = {...content, [key]: entry.newBlock}
    //   // }

    // }
    this.content = new ControlManagerContainerContent({
      ...this.getHiddenBlocks(),
      ...newContent
    })
    this.setSources()
  }

  traverseBlocks(keyConditionCallback, actionCallback) {
    let content = this.content.getData()

    for (let blockKey in content) {
      if (keyConditionCallback(blockKey)) {
        actionCallback(blockKey, content)
      }
    }
    return content
  }



  serialize() {
    if (this._language_v2) {
      this.unsetSchemas()
      this.unsetSources()
    }
    let superSerialized = super.serialize()
    if (this._language_v2) {
      this.setSchemas()
      this.setSources()
    }
    let langId = this.langId
    let reportSections = this.reportSections
    let coverPageContent = this.coverPageContent
    let schema = this.schema
    let dirName = this.dirName
    let name = this.getTitle()
    let _property = this._property
    let _language_v2 = this._language_v2
    let users = this.users

    let _client = this._client
    // let _createdFor = this._createdFor
    // console.log('about to return serialized report', {
    //   ...superSerialized,
    //   langId,
    //   reportSections,
    //   coverPageContent,
    //   schema,
    //   _language_v2

    // })
    return {
      ...superSerialized,
      langId,
      reportSections,
      coverPageContent,
      schema,
      dirName,
      name,
      _property,
      // _createdFor,
      _language_v2,
      users,
      _client
    }
  }

  static getShouldSortKey(key) {
    return ~key.indexOf(REP_BLOCK_TAG)
  }

  static getBlockKeyFromTree(tree) {
    return `${REP_BLOCK_TAG}` +
      `${tree.reportSection.content[0]._name}` +
      `::${tree.category.content[0]._name || ''}` +
      `::${tree.subcategory.content[0]._name || ''}`
  }

  static getTypeDir() {
    return REP
  }

  setClient(client) {
    console.log('setClient: data before setting:', client, this)
    this._client = client._id
    this.content.content.title.tree.preparedForName = { content: [{ _name: client.name }] }
    this.content.content.title.tree.preparedForAddress = { content: [{ _name: client.getAddress() }] }
  }

  getTitle() {
    let title
    if (this.content.getData().title.tree.title) {
      title = this.content.getData().title.tree.title.content[0]._name
    } else {
      title = this.content.getData().title.source.title[0]
    }
    // console.log("got my title from content", title)
    if (title._name) title = title._name
    return title
  }

  getContents(all = false) {
    const blocks = this.content.content
    let list = {}
    // console.log('getting cotnent from', blocks)
    for (const blockName in blocks) {

      const block = blocks[blockName]
      if (!Report.getShouldSortKey(blockName)) {
        if (!all || blockName[0] === '_') continue
        let val

        // switch(blockName){
        //   case 'title':
        //     val='Title Block';
        //     break;
        //   case 'summary':
        //     val='Summary Block';
        //     break;
        //   case 'reportSectionSelector':
        //     val='Report Section Selector';
        //     break;
        // }

        if (blockName === 'title') val = 'Title Block'
        else if (blockName === 'summary') val = 'Summary Block'
        else if (blockName === 'reportSectionSelector') val = 'Report Section Selector'
        else if (~blockName.indexOf('preamble')) val = block.tree.title.content[0]._name


        block.tree.blockName = { content: [{ _name: val }] }
        block.tree.reportSection = { content: [{ _name: 'Top' }] }
      }


      const blockLabel =
        (block.tree.blockName &&
          block.tree.blockName.content &&
          block.tree.blockName.content.length &&
          block.tree.blockName.content[0]._name) ||
        'No title yet'
      let repSection = block.tree.reportSection
      let sectionName = 'No section'
      if (repSection) {
        let content = repSection.content
        if (content.length) {
          if (typeof content === 'string') sectionName = content
          else sectionName = content[0]._mask || content[0]._name
        }
      }
      list[sectionName] = list[sectionName] || {}
      list[sectionName][blockLabel] = blockName
    }
    // console.log('resulting list', list)
    return list
  }

  setBlockTitle(block, title) {
    const thisTree = this.content.content[block].tree
    thisTree.blockName = thisTree.blockName || {}
    thisTree.blockName.content = [{ _name: title, _mask: title }]
  }

  getName() {
    if (this.directory) {
      // console.log(this.directory, this.ownPath)
      return this.ownPath.substring(this.ownPath.lastIndexOf('/') + 1)
    }
  }

  getReportSchema() {
    console.log('getting schema in report', this.content)
    return this.content._reportSchema ? this.content._reportSchema.schema : this.content.content._reportSchema.schema
  }

  getReportSource() {
    // console.log('getting source in report', this.content)
    const source = this.content._reportSchema ? this.content._reportSchema.source : this.content.content._reportSchema.source
    const reportSection = this.content.reportSectionSelector ? this.content.reportSectionSelector.source.reportSection :
      this.content.content.reportSectionSelector.source.reportSection
    return {
      ...source,
      reportSection
    }
  }

  getPreambleSchema() {
    // console.log('getting schema in report', this.content)
    return this.content.content._preambleSchema.schema
  }

  //path variable for potential drop in
  async addPhoto(ds, syncPut, locRoot, photo, path, reportMarker, token, copyManager, allNames) {
    // let mark = await ds('db')[MARK].getTyped({_id: photo._id})
    // console.log("IS THIS PHOTO USELESS?", photo, allNames)
    if (!photo && !path) return



    let dropboxDir = `${DROPDIR}/${REP_MARK}/${this.dirName}/${PHOTOS_SM}`
    if (photo) {
      // let createFolderRes
      // try{
      //   createFolderRes = await createDropboxFolder(dropboxDir, token)
      // }catch(e){
      //   let res = await checkDropboxPath(dropboxDir, token)
      //   if(!res||res.error){
      //     console.log('not good', e, res)
      //     return false
      //   }
      // }
      // let copyRes
      try {
        // console.log('get dbx path for', photo)
        let photoDropboxPath = await photo.getDropboxPath(null, ds)
        // console.log(photoDropboxPath)
        copyManager.copyFile(photoDropboxPath, `${dropboxDir}/${reportMarker._id}_sm.jpg`, token)
        // copyRes = fileCopy(photoDropboxPath, `${dropboxDir}/${reportMarker._id}_sm.jpg`, token)
      } catch (e) {
        console.log('not good at all', e)
      }
    }

    let content = this.content.getData()
    // console.log('got marker from db and content from self', mark, content, reportMarker)
    // console.log('attempting to get photoKey from Photo', photo)
    let photoKey = Report.getBlockKeyFromTree(photo.getTree())


    let {
      reportSection,
      mastercat,
      category,
      subcategory,
      location: loc,
      area,
      space,
    } = photo.content.getData().data.tree

    if (!content[photoKey]) {

      // console.log('adding block with', photo.content.getData().data.tree)
      // console.log(category, subcategory)
      // let [secNum, catNum, subNum] =subcategory.content[0][`!fullNum`].split('.')
      // let titleNum = [catNum, subNum].join('.')
      // let blockTitle= `${titleNum} ${subcategory.content[0]._mask||subcategory.content[0]._name}`
      // let cat = allNames[category.content[0]._name]
      let subcat = allNames[subcategory.content[0]._name]
      // console.log('seek subcat', subcategory.content[0]._name)
      // console.log( subcategory.content[0]._name)
      // console.log(allNames)
      // console.log(subcat)
      let fullNum = subcat[`!fullNum`] || subcat[`!fullnum`]
      let [catNum, subNum] = fullNum.split('.').slice(1)
      
      let titleNum = [catNum, subNum].join('.')
      let newTitle = [{ _name: `${titleNum}: ${subcat._mask || subcat._name}` }]


      this.addBlock(photoKey, {
        tree: {
          reportSection,
          mastercat,
          category,
          subcategory,
          blockName: { content: newTitle }
        },
      })
    }
    let imageContent = this.getImageContentByPhotoKey(photoKey)
    // console.log('got current imageContent', loc, area, space)
    let caption = []
    for (let itm of [loc, area, space]) {
      if (itm && itm.content && itm.content[0] && itm.content[0]._name)
        caption.push(itm.content[0]._name)
    }
    caption = caption.join(', ')

    imageContent = [...imageContent, { photo: reportMarker._id, caption }]
    this.setImageContentByPhotoKey(photoKey, imageContent)
    // console.log('added photo', this.content, this.getImageContentByPhotoKey(photoKey))
    // return
    // console.log('putting report marker', reportMarker)
    return await syncPut(REP_MARK, reportMarker.serialize())
    // await ds('remDb')[REP_MARK].put(reportMarker.serialize())
    // await ds('db')[REP_MARK].put(reportMarker.serialize())
  }

  setImageContentByPhotoKey(photoKey, imageContent) {
    let content = this.content.getData()
    // console.log('setting New Content', content)
    let newContent = new ControlManagerContainerContent({
      ...content,
      [photoKey]: {
        ...content[photoKey],
        tree: {
          ...content[photoKey].tree,
          images: {
            content: [{ _name: JSON.stringify(imageContent) }],
          },
        },
      },
    })
    this.content = newContent
  }

  getImageContentByPhotoKey(photoKey) {
    let data = this.content.getData()
    if (
      data[photoKey].tree.images &&
      data[photoKey].tree.images.content
    ) {
      let rawName = data[photoKey].tree.images.content[0]._name || ''
      let res = JSON.parse(rawName)
      // console.log('got content', res)
      return res
    } else {
      // console.log('couldnt get data', this.content.getData)
      return []
    }
  }

  addBlock(key, content) {
    let newContent = new ControlManagerContainerContent({ ...this.getUnhiddenBlocks(), ...this.getHiddenBlocks(), ...this.generateNewBlock(key, content) })
    this.content.content = newContent.content
    console.log('added block to report', this.content, key, content)
  }

  generateNewBlock(key = `${REP_BLOCK_TAG}${genId()}`, content = {}) {
    return {
      [key]: {
        schema: this.getReportSchema(),
        source: this.getReportSource(),
        tree: {
          category: { content: [{ _name: 'No category', '!num': '000' }] },
          subcategory: { content: [{ _name: 'No subcategory', '!num': '000' }] },
          reportSection: { content: [{ _name: 'No section' }] },
          blockName: { content: [{ _name: 'New Block' }] },
        },
        ...content
      },
    }
  }

  addMultipleBlocks(blocks) {
    for (let blockKey in blocks) {
      blocks[blockKey].schema = this.getReportSchema()
      blocks[blockKey].source = this.getReportSource()
      blocks[blockKey].tree = {
        category: { content: [{ _name: 'No category', '!num': '000' }] },
        subcategory: { content: [{ _name: 'No subcategory', '!num': '000' }] },
        reportSection: { content: [{ _name: 'No section' }] },
        blockName: { content: [{ _name: 'New Block' }] },
        ...blocks[blockKey],
      }
    }
    this.content.content = new ControlManagerContainerContent({
      ...this.content,
      ...blocks
    })
    console.log('added blocks to report', this.content, blocks)
  }

  addPreambleBlock(key = `${PRE_TAG}${genId()}`, content = {}) {
    let topBlocks = this.getTopBlocks()
    let preBlocks = this.getPreambleBlocks()
    let repBlocks = this.getReportBlocks()
    let hidBlocks = this.getHiddenBlocks()

    this.content = new ControlManagerContainerContent({
      ...topBlocks,
      ...preBlocks,
      [key]: {
        schema: this.getPreambleSchema(),
        tree: {
          title: { content: [{ _name: 'Preamble Block' }] },
          reportSection: { content: [{ _name: 'Top' }] },
          image: { content: [{ _name: '' }] },
          caption: { content: [{ _name: '' }] }
        },
        ...content,
      },
      ...repBlocks,
      ...hidBlocks,
    })
    return [key, Object.keys(this.content.content).indexOf(key)]
  }

  getBlocksByTag(compareCallback) {
    let contents = this.content && this.content.getData()
    if (!this.content) return []
    let contentKeys = Object.keys(contents)
    let resKeys = contentKeys.filter(compareCallback)
    let res = {}
    for (let key of resKeys) res[key] = contents[key]

    return res
  }

  getPreambleBlocks() {
    return this.getBlocksByTag(itm => ~itm.indexOf(PRE_TAG))
  }

  getReportBlocks() {
    return this.getBlocksByTag(itm => ~itm.indexOf(REP_BLOCK_TAG))
  }

  getTopBlocks() {
    return this.getBlocksByTag(itm => ['title', 'summary', 'reportSectionSelector'].includes(itm))

  }
  getUnhiddenBlocks() {
    return this.getBlocksByTag(itm => !(itm[0] === '_'))

  }
  getHiddenBlocks() {
    return this.getBlocksByTag(itm => itm[0] === '_')
  }

  setLang(langFile) {
    // console.log('setting lang', langFile)
    const lang = langFile && langFile.content[0].tree.binding.content
    let content = this.content
    if (content.content) content = content.content
    content = content || {}
    content.inspPerform = content.inspPerform || {}
    content.inspPerform.source = content.inspPerform.source || {}
    content.inspPerform.source.language = lang
  }

  unsetSources(content = this.content.content) {
    let arr = this.getReportBlocks()
    for (let blockKey in arr) {
      if (content[blockKey].source && content[blockKey].source.language) {
        content[blockKey].source.language = {}
      }// itm.source=''
    }
    this._tempSource = { ...content._reportSchema.source }
    if (content._reportSchema.source && content._reportSchema.source.language) {
      content._reportSchema.source.language = {}
    }

    return content
  }

  setSources(content = this.content.content) {
    let arr = this.getReportBlocks()

    if (this._tempSource) {
      content._reportSchema.source = { ...this._tempSource }
      this._tempSource = false
    }
    for (let blockKey in arr) {
      let itm = content[blockKey]
      itm.schema = content._reportSchema.schema
      itm.source.language = content._reportSchema.source && content._reportSchema.source.language
    }

  }

  unsetSchemas(content = this.content.content) {
    let arr = this.getReportBlocks()
    for (let blockKey in arr) {
      let itm = content[blockKey]
      itm.schema = []
      for (let branchKey in itm.tree) {
        itm.tree[branchKey] = { content: itm.tree[branchKey].content }
      }
    }
  }

  setSchemas(content = this.content.content) {
    let arr = this.getReportBlocks()
    for (let blockKey in arr) {
      let itm = content[blockKey]
      itm.schema = content._reportSchema.schema
      for (let branchKey in itm.tree) {
        traverseSchema(itm.schema, {}, itm.tree, (control, src,) => {
          if (control.name === branchKey) {
            itm.tree[branchKey] = { ...itm.tree[branchKey], name: control.name, label: control.label }

            return false
          }
        })
      }
    }
  }

  async getLocalPhotoList(root, readDir, checkIfExists) {
    const localDir = `${root}/${REP_MARK}/${this.dirName || this.name}/${PHOTOS_SM}`
    // console.log('local dir', localDir, this)
    let dirContents = []
    try {
      let exists = await checkIfExists(localDir)
      if (exists) {
        dirContents = await readDir(localDir)
      }
    } catch (e) {
      console.log('failed reading directory for counting local insp fin photos', e)
    }
    // console.log('read dir for insp fin', dirContents)
    return dirContents
  }

  async countLocalPhotos(root, readDir, checkIfExists) {
    const localDir = this.getLocalPhotoList(root, readDir, checkIfExists)
    return localDir.length
  }

  unwrapval(content) {
    if (Array.isArray(content)) return content[0]._name
    else if (typeof content === 'string') return content

    return content._name
  }

  getMiscImageIds() {
    let preambleBlocks = this.getPreambleBlocks()
    let imgIds = []
    let data = this.content.getData(true)
    // console.log('attempting to get misc img ids for report', preambleBlocks, data)
    if (data.title.tree.coverPhoto && data.title.tree.coverPhoto.content.length) imgIds.push(this.unwrapval(data.title.tree.coverPhoto.content))
    if (data.title.tree.preparedByPhoto && data.title.tree.preparedByPhoto.content.length) imgIds.push(this.unwrapval(data.title.tree.preparedByPhoto.content))
    if (data.title.tree.preparedForPhoto && data.title.tree.preparedForPhoto.content.length) imgIds.push(this.unwrapval(data.title.tree.preparedForPhoto.content))
    if (data.summary.tree.signature && data.summary.tree.signature.content.length) imgIds.push(this.unwrapval(data.summary.tree.signature.content))
    for (let preKey in preambleBlocks) {
      if (preambleBlocks[preKey].tree.image.content.length && !preambleBlocks[preKey].tree.image.content[0]._name.includes('data'))
        imgIds.push(preambleBlocks[preKey].tree.image.content[0]._name)
    }
    return imgIds
  }

  getCurrentImageIds() {
    let allContentKeys = this.getContents()
    let data = this.content.getData()
    // console.log('got all contents,', allContentKeys, data)

    let imageIds = []
    for (let section in allContentKeys) {
      for (let blockName in allContentKeys[section]) {
        const blockKey = allContentKeys[section][blockName]
        // console.log('got block images', data[blockKey])
        if (data[blockKey].tree.images.content && data[blockKey].tree.images.content[0]) {
          let imgBlock = JSON.parse(data[blockKey].tree.images.content[0]._name)
          //checking for a stupid error i made
          let imgBlockContainsData64 = imgBlock.find(itm => itm.photo.includes('data'))
          if (imgBlockContainsData64) {
            let cleanBlock = imgBlock.filter(itm => !itm.photo.includes('data'))
            this.content.content[blockKey].tree.images.content[0]._name = JSON.stringify(cleanBlock)
            imgBlock = cleanBlock
          }
          imageIds = [...imageIds, ...imgBlock.map(itm => itm.photo)]
        }

      }
    }

    // console.log('got all image ids', imageIds)
    return imageIds
  }
}
